<div class="results-wrapper" *ngIf="results">

    <div class="results-header" *ngIf="exactFiltered?.length > 0">
            <div class="header-text">These look like a good fit</div>
            <app-section-label mobileSize="14px">
                Parties with matching travel plans and preferences
            </app-section-label>
    </div>

    <div class="provider-filter" *ngIf="providerOptions.length > 1">
        <div class="filter-copy">
            <div class="filter-title">Provider filter</div>
            <div class="filter-detail">Starts on all results. Use this only to narrow the visible list.</div>
        </div>
        <app-toggle-item-row [(value)]="selectedProvider" iconURL="assets/svg/filter-outline.svg" [options]="providerOptions" (valueChange)="onFilterValueChange()"></app-toggle-item-row>
    </div>

    <div class="results-list" *ngIf="results">

        <div class="exact-results" *ngIf="exactFiltered?.length > 0">

            <div class="items">
                <app-flight-option-card *ngFor="let r of exactFiltered" [flightOption]="r"
                    (click)="onClickResult(r)"></app-flight-option-card>
            </div>

        </div>

        <div class="similar-results" *ngIf="results.similarMatches?.length > 0">

            <div class="results-header">
                <div class="header-text">Plans that are similar to yours</div>
            </div>

            <div class="sections" *ngIf="similarFilteredSections?.length > 0; else emptySimilar">
                <div class="section" *ngFor="let s of similarFilteredSections">
                    <div class="section-row">
                        <div class="pill">
                            <div class="section-icon">
                                <app-svg-loader height="16px"
                                    url="assets/logos/tail-one-logo-chip-gradient-black.svg"></app-svg-loader>
                            </div>
                            <div class="text">
                                "{{s.description}}"
                            </div>
                        </div>
                    </div>
                    <app-flight-option-card *ngFor="let r of s.options" [flightOption]="r"
                        (click)="onClickResult(r)"></app-flight-option-card>
                </div>
            </div>

            <ng-template #emptySimilar>
                <div id="r-card" class="empty-state">
                    <div>No Similar Matches for {{ selectedProviderLabel }}</div>
                    <button type="button" *ngIf="selectedProvider !== 'All & Independent'" (click)="clearProviderFilter()">Show all providers</button>
                </div>
            </ng-template>

        </div>

        <app-secondary-btn class="assign-agent-action" variant="action-panel" (click)="onClickAssignToAgent()">
            <div class="featured-btn-text">
                <div class="large">Assign to Agent</div>
                <div class="small">Get email updates when new options are available</div>
            </div>
        </app-secondary-btn>

    </div>
</div>

<app-request-connection-overlay *ngIf="appState.agent.selectedOption()"></app-request-connection-overlay>

<app-agent-setup-watcher *ngIf="showAssignToAgent" (onClose)="onClickCancelAssign()"
    [flightData]="appState.agent.currentDataModel()"></app-agent-setup-watcher>
